import {useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useGuideFlowProviderContext} from "../../../../../GuideFlowProviderContext";
import {JournalContent} from "../../../../../providers/journal/JournalProvider";
import {RichTextViewer} from "../../../../controls/vidence/richtext/RichTextViewer";

export default function JournalEntryDetailsScreen() {
    const {id} = useParams();
    const [isLoaded, setIsLoaded] = useState(false);
    const [journalContent, setJournalContent] = useState<JournalContent | null>();
    const context = useGuideFlowProviderContext();
    useEffect(() => {
        setIsLoaded(false);
        context.Journal.getContent(id).then(c => {
            setJournalContent(c);
            setIsLoaded(true)
        });

    }, [context.Journal, context.Journal.StateChanged, id]);

    if (!isLoaded) {
        return <div>Loading...</div>
    }

    if (!journalContent?.jsonContent) {
        return <div>json content is empty</div>
    }

    let content;
    if (isDoubleEncoded(journalContent.jsonContent)) {
        console.log("content is double encoded");
        content = fixDoubleEncodedLexical(journalContent.jsonContent);
    } else {
        console.log("content is not double encoded");
        content = JSON.parse(journalContent.jsonContent);
    }

    console.log("final-content", content);

    return (
        <div className="w-full m-3 mt-5">
            <RichTextViewer initialJson={content} />
        </div>
    );
}

function isDoubleEncoded(jsonStr) {
    try {
        const parsed = JSON.parse(jsonStr);
        if (typeof parsed === "string") {
            try {
                JSON.parse(parsed);
                return true; // It parses again → double encoded
            } catch {
                return false;
            }
        }
        return false;
    } catch {
        return false;
    }
}

function fixDoubleEncodedLexical(jsonStr) {
    let parsed = JSON.parse(jsonStr);
    if (typeof parsed === "string") {
        parsed = JSON.parse(parsed); // parse again
    }
    return parsed; // <- no wrapping
}